import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12da966d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-share has-background-contents" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "panel-share-div" }
const _hoisted_4 = { class: "panel-share-sns level is-mobile" }
const _hoisted_5 = { class: "panel-share-url" }
const _hoisted_6 = { class: "has-text-table-item-name has-text-title" }
const _hoisted_7 = { class: "panel-share-url-copy level is-mobile" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "panel-share-div" }
const _hoisted_10 = { class: "has-text-table-item-name has-text-title level-left is-mobile" }
const _hoisted_11 = { class: "item-list-view-rights" }
const _hoisted_12 = {
  key: 0,
  "data-cy": "panel-share-internet-rights-message"
}
const _hoisted_13 = {
  key: 1,
  "data-cy": "panel-share-internet-rights-message"
}
const _hoisted_14 = { class: "panel-share-rights-description" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "panel-share-div"
}
const _hoisted_18 = { class: "has-text-table-item-name has-text-title" }
const _hoisted_19 = { class: "panel-share-rights-copy level is-mobile" }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 3,
  class: "panel-share-div",
  id: "panel-share-doi-area"
}
const _hoisted_22 = { class: "has-text-table-item-name has-text-title" }
const _hoisted_23 = { class: "panel-share-doi-url" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 4 }
const _hoisted_26 = {
  key: 5,
  class: "panel-share-div",
  id: "panel-share-manifest-uri-area"
}
const _hoisted_27 = { class: "has-text-table-item-name has-text-title" }
const _hoisted_28 = { class: "panel-share-manifest-uri" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { key: 6 }
const _hoisted_31 = {
  key: 7,
  class: "panel-share-div",
  id: "panel-share-database-linker-area"
}
const _hoisted_32 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTwitter = _resolveComponent("IconTwitter")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_IconFacebook = _resolveComponent("IconFacebook")!
  const _component_IconLine = _resolveComponent("IconLine")!
  const _component_IconEmail = _resolveComponent("IconEmail")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_ButtonCopyClipboard = _resolveComponent("ButtonCopyClipboard")!
  const _component_AppIconPlaces = _resolveComponent("AppIconPlaces")!
  const _component_AppLabelPlaces = _resolveComponent("AppLabelPlaces")!
  const _component_AppTextarea = _resolveComponent("AppTextarea")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_IconIIIF = _resolveComponent("IconIIIF")!
  const _component_TextWithLeadingIcon = _resolveComponent("TextWithLeadingIcon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('sharePanel.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_AppButton, {
          styled: "is-none",
          "aria-label": _ctx.$t('label.tweet'),
          onClick: _ctx.onTwitter,
          onKeydown: _withKeys(_withModifiers(_ctx.onTwitter, ["prevent"]), ["space","enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconTwitter, { size: "40" })
          ]),
          _: 1
        }, 8, ["aria-label", "onClick", "onKeydown"]),
        _createVNode(_component_AppButton, {
          styled: "is-none",
          "aria-label": _ctx.$t('label.facebook'),
          onClick: _ctx.onFacebook,
          onKeydown: _withKeys(_withModifiers(_ctx.onFacebook, ["prevent"]), ["space","enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconFacebook, { size: "40" })
          ]),
          _: 1
        }, 8, ["aria-label", "onClick", "onKeydown"]),
        _createVNode(_component_AppButton, {
          styled: "is-none",
          "aria-label": _ctx.$t('label.line'),
          onClick: _ctx.onLine,
          onKeydown: _withKeys(_withModifiers(_ctx.onLine, ["prevent"]), ["space","enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconLine, { size: "40" })
          ]),
          _: 1
        }, 8, ["aria-label", "onClick", "onKeydown"]),
        _createVNode(_component_AppButton, {
          styled: "is-none",
          "aria-label": _ctx.$t('label.mail'),
          onClick: _ctx.onMail,
          onKeydown: _withKeys(_withModifiers(_ctx.onMail, ["prevent"]), ["space","enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconEmail, { size: "40" })
          ]),
          _: 1
        }, 8, ["aria-label", "onClick", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('sharePanel.resourceUrl')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_AppInput, {
            modelValue: _ctx.itemUrl,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemUrl) = $event)),
            readonly: true,
            class: "flex-grow",
            label: _ctx.$t('sharePanel.resourceUrl')
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_ButtonCopyClipboard, {
            icon: "copy",
            styled: "is-none",
            "target-text": _ctx.itemUrl,
            label: _ctx.$t('label.copyUrl'),
            class: "has-form-label"
          }, null, 8, ["target-text", "label"])
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h2", _hoisted_10, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('parts.accessRestrictions')), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_AppLabelPlaces, {
            type: _ctx.permissionColor,
            class: _normalizeClass(["level-left is-mobile", `panel-share-rights-icon-${_ctx.permissionRule}`])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AppIconPlaces, { type: _ctx.permissionRule }, null, 8, ["type"]),
              _createElementVNode("span", null, _toDisplayString(_ctx.permissionText), 1)
            ]),
            _: 1
          }, 8, ["type", "class"])
        ]),
        (_ctx.item.rights?.code === 'undet')
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('internetRightsMessage.undet')), 1))
          : (_ctx.displayInternetRightsCodeMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('internetRightsMessage.emptyRightsCode')), 1))
            : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.rightsDescription), 1),
        _createElementVNode("a", {
          class: "panel-share-rights-description-link level-left is-mobile",
          id: "panel-share-rights-description-link",
          href: _ctx.$t('link.aboutReproduction'),
          rel: "noopener"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('parts.detail')), 1)
        ], 8, _hoisted_15)
      ])
    ]),
    (_ctx.shouldShowPanelShareRightsCopy)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_16))
      : _createCommentVNode("", true),
    (_ctx.shouldShowPanelShareRightsCopy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("h2", _hoisted_18, _toDisplayString(_ctx.$t('sharePanel.inputExmaple')), 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_AppTextarea, {
              modelValue: _ctx.accessRights,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accessRights) = $event)),
              readonly: true,
              class: "flex-grow",
              rows: "4",
              label: _ctx.$t('sharePanel.inputExmaple')
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_component_ButtonCopyClipboard, {
              icon: "copy",
              styled: "is-none",
              "target-text": _ctx.accessRights,
              label: _ctx.$t('label.copyNotationExample'),
              class: "has-form-label"
            }, null, 8, ["target-text", "label"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.doi)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_20))
      : _createCommentVNode("", true),
    (_ctx.doi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("h2", _hoisted_22, _toDisplayString(_ctx.$t('sharePanel.doi')), 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("a", {
              class: "panel-share-doi-url-link level-left is-mobile",
              href: _ctx.DOI_BASE_URL + _ctx.doi,
              target: "_blank",
              rel: "noopener"
            }, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.doi) + " ", 1),
                _createVNode(_component_DssIcon, {
                  id: "panel-share-doi-share-icon",
                  icon: "action-share-mini",
                  size: "is-small"
                })
              ])
            ], 8, _hoisted_24)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.manifestUri)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_25))
      : _createCommentVNode("", true),
    (_ctx.manifestUri)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t('sharePanel.manifestUri')), 1),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("a", {
              href: _ctx.manifestUri,
              rel: "noopener",
              class: "level-left is-mobile"
            }, [
              _createVNode(_component_IconIIIF),
              _createElementVNode("span", null, _toDisplayString(_ctx.manifestUri), 1)
            ], 8, _hoisted_29)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDispDatabaseLink)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_30))
      : _createCommentVNode("", true),
    (_ctx.isDispDatabaseLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("a", {
            href: `${_ctx.databaseLinkerRoot}rft.btitle=${_ctx.metaItem(_ctx.item.meta['0001Dtct'])}&rft.au=${_ctx.metaItem(_ctx.item.meta['0010Dtct'])}&rft.pub=${_ctx.metaItem(_ctx.item.meta['0020Dtct'])}&ctx_ver=${_ctx.urlVer}&rfr_id=${_ctx.rfrId}&url_ver=${_ctx.urlVer}&ctx_enc=${_ctx.ctxEnc}&rft.val_fmt=${_ctx.rftValFmt}&url_ctx_fmt=${_ctx.urlCtxFmt}`,
            rel: "noopener"
          }, [
            _createVNode(_component_TextWithLeadingIcon, {
              tag: "p",
              icon: "magnifyingglass"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('sharePanel.searchOnDB')), 1)
              ]),
              _: 1
            })
          ], 8, _hoisted_32)
        ]))
      : _createCommentVNode("", true)
  ]))
}